export default "__VITE_ASSET__DCnZ3zFM__"